import React, { useCallback, useEffect, useRef } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import CartInfo from '../../components/CartPage/CartInfo/CartInfo';
import { cartPageStyle as styles } from './cartPage.tailwind.js';
import { getMyCart } from '../../redux/slices/cartSlice.js';
import { connect, useSelector } from 'react-redux';
import CommonLoader from '../../components/shared/Loaders/CommonLoader/CommonLoader.jsx';
import PaymentDetails from '../../components/CartPage/PaymenDetails/PaymenDetails.jsx';
import OverlayLoader from '../../components/shared/Loaders/OverlayLoader/OverlayLoader.jsx';

// My Cart
const CartPage = ({ getCart }) => {
  const apiDataRef = useRef(false);
  const { products: orderItems, loadingCart, checkingOutPayment, checkingOutPaymentCoins } = useSelector(state => state.cart)
  const { currentSeason } = useSelector((state) => state.seasons);

  const callApi = useCallback(async () => {
    if(apiDataRef.current) return;
    apiDataRef.current = true;
    await getCart({
      seasonId: currentSeason?._id
    });
  }, [getCart, currentSeason]);

  useEffect(() => {
    callApi();
  }, [callApi]);

  if(loadingCart || !apiDataRef.current) return <CommonLoader />

  return (
    <main className='min-h-[100vh]'>
      <Navbar showSeasonDropdown={true} />
      {/* Show Loader while checking Out FOR DEMO added checkingOutPaymentCoins */}
      {(checkingOutPayment || checkingOutPaymentCoins) && <OverlayLoader />}

      <section  className={`${styles.wrapper} ${(orderItems && orderItems?.length > 0) ? 'flex' : ''}`}
        style={{
          gridTemplateColumns: orderItems && orderItems.length > 0 ? "68% 29%" : "100%",
          minHeight: "calc(100% - 140px)"
        }}>
          <CartInfo />
          {(orderItems && orderItems?.length > 0) && <PaymentDetails />}
      </section>
    </main>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCart: (data) => dispatch(getMyCart(data)),
  };
};

export default connect(null, mapDispatchToProps)(CartPage);